import { render, staticRenderFns } from "./TemplateDeck.vue?vue&type=template&id=6002276c&scoped=true&lang=pug&"
import script from "./TemplateDeck.vue?vue&type=script&lang=js&"
export * from "./TemplateDeck.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDeck.vue?vue&type=style&index=0&id=6002276c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6002276c",
  null
  
)

export default component.exports